export const PRICING_HELP = {
  Priced: 'Twilio returned a vendor price for this resource. A zero amount is still a price.',
  'Waiting for Twilio': 'Twilio has not published a price yet. This amount is not in the priced total.',
  'Retry scheduled': 'Price collection will try again on its own. This amount is not in the priced total.',
  'Pricing failed': 'A vendor price could not be collected. This amount is not in the priced total.',
  Unallocated: 'This usage is not assigned to a tenant. It is not billed to any customer.',
  Reconciled: 'The parent and child records for this activity were matched.',
  Attributed: 'This usage is assigned to the tenant shown.',
};

const FEATURE_LABELS = {
  sip_paging: 'SIP paging',
  browser_pstn: 'Browser PSTN',
  sip_outbound: 'SIP outbound',
  sms_outbound: 'SMS',
  sms_inbound: 'SMS inbound',
  voice_call: 'Voice call',
  contact_list_call: 'Contact list call',
};

export function monthlyPricingState(summary) {
  const total = Number(summary?.totalItems || 0);
  const pending = Number(summary?.pendingPriceCount || 0);
  const failed = Number(summary?.failedPricingCount || 0);
  const priced = (summary?.currencies || []).reduce(
    (sum, row) => sum + Number(row?.pricedItems || 0),
    0,
  );
  if (total <= 0) return { id: 'none', label: 'No usage' };
  if (failed > 0) return { id: 'attention', label: 'Pricing attention required' };
  if (priced <= 0 && pending > 0) return { id: 'pending', label: 'Pricing pending' };
  if (pending > 0) return { id: 'partial', label: 'Partially priced' };
  return { id: 'complete', label: 'Pricing complete' };
}

export function currentUtcMonth(date = new Date()) {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

export function formatVendorAmount(amount, currency) {
  if (amount == null || amount === '') return '—';
  const text = String(amount);
  return currency ? `${currency} ${text}` : text;
}

export function formatVendorCosts(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return '—';
  return rows
    .map((row) => formatVendorAmount(row.amount ?? row.pricedVendorCost, row.currency))
    .join(', ');
}

export function formatDuration(seconds) {
  const total = Number(seconds);
  if (!Number.isFinite(total) || total < 0) return '—';
  const whole = Math.floor(total);
  const minutes = Math.floor(whole / 60);
  const remain = whole % 60;
  if (minutes === 0) return `${remain}s`;
  if (remain === 0) return `${minutes} min`;
  return `${minutes}m ${remain}s`;
}

export function formatUtc(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return String(iso);
  return date.toISOString().replace('T', ' ').replace('.000Z', ' UTC').replace('Z', ' UTC');
}

export function formatFeature(feature) {
  if (!feature) return '—';
  return FEATURE_LABELS[feature] || String(feature).split('_').join(' ');
}

export function formatDirection(direction) {
  if (!direction) return '—';
  return String(direction).split('_').join(' ');
}

export function formatLeg(leg) {
  if (leg === 'parent') return 'Parent';
  if (leg === 'child') return 'Child';
  return '—';
}
